import Wide from 'bcl/components/input/wide';
import { on } from '@ember/modifier';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type CompanyModel from 'bcl/models/company';
export default <template>
  <h2
    id="company"
    class="text-xl font-semibold leading-7 text-gray-900"
  >Unternehmen</h2>
  <form class="mx-4 sm:mx-0">
    <div class="space-y-12">
      <div class="border-b border-gray-900/10 pb-12">
        <div class="grid grid-cols-1 gap-x-6 sm:grid-cols-6">
          {{! Allgemein }}
          <Wide
            @label="Firma"
            @name="name"
            @type="text"
            @value={{@model.name}}
          />
          <Wide
            @label="Steuernummer"
            @name="tax_number"
            @type="text"
            @value={{@model.tax_number}}
          />
        </div>
        {{! Anschrift }}
        <h2
          class="text-base font-semibold leading-7 text-gray-900"
        >Anschrift</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">Anschrift des
          Unternehmens</p>
        <div class="grid grid-cols-1 gap-x-6 sm:grid-cols-6">

          <Wide
            @label="Straße"
            @name="street"
            @type="text"
            @value={{@model.street}}
          />
          <Wide
            @label="Haus-Nr"
            @name="streetNr"
            @type="text"
            @value={{@model.street_number}}
          />
          <Wide
            @label="PLZ"
            @name="zip_code"
            @type="text"
            @value={{@model.zip_code}}
          />
          <Wide
            @label="Ort"
            @name="place"
            @type="text"
            @value={{@model.place}}
          />

        </div>
        {{! Kontakt }}
        <h2 class="text-base font-semibold leading-7 text-gray-900">Kontakt</h2>
        <p
          class="mt-1 text-sm leading-6 text-gray-600"
        >Standardkontaktmöglichkeiten</p>
        <div class="grid grid-cols-1 gap-x-6 sm:grid-cols-6">

          <Wide
            @label="Ansprechpartner"
            @name="contactPerson"
            @type="text"
            @value={{@model.contact_person}}
          />
          <Wide
            @label="Telefonnummer"
            @name="telefon"
            @type="text"
            @value={{@model.telefon_number}}
          />
          <Wide
            @label="Fax"
            @name="fax"
            @type="text"
            @value={{@model.fax_number}}
          />
          <Wide
            @label="Mail"
            @name="email"
            @type="text"
            @value={{@model.email}}
          />
          <Wide
            @label="Mobil"
            @name="mobile_number"
            @type="text"
            @value={{@model.mobile_number}}
          />

        </div>

      </div>
    </div>

    <div class="mt-6 flex items-center justify-end gap-x-6">
      <button
        type="button"
        {{on "click" @cancel}}
        class="text-sm font-semibold leading-6 text-gray-900"
      >Abbrechen</button>
      <button
        {{on "click" @save}}
        type="button"
        class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >Speichern</button>
    </div>
  </form>
</template> satisfies TemplateOnlyComponent<{
  Args: {
    model: CompanyModel;
    save: () => void;
    cancel: () => void;
  };
}>;
